import React from 'react';

const RoomIconToolTip = ({options = {}}) => {

  const {className = '', attributeName = '', description = ''} = options;

  return (
    <div key={`icon-${className}`} className="vw-rmd room-tooltip">
      <i className={`${className} d-inline-block hidden-md-down`}/>

      <div className="attribute-content d-inline-block">
        <h4 className="attribute-heading">{attributeName}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default RoomIconToolTip;



// WEBPACK FOOTER //
// ./js/components/step2/room-icons/RoomIconToolTip.js